import { render, staticRenderFns } from "./ProcessingPage.vue?vue&type=template&id=b472687c&scoped=true"
import script from "./ProcessingPage.vue?vue&type=script&lang=ts"
export * from "./ProcessingPage.vue?vue&type=script&lang=ts"
import style0 from "./ProcessingPage.vue?vue&type=style&index=0&id=b472687c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b472687c",
  null
  
)

export default component.exports